import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSeparator = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 16 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0.624023 -1L14.624 20.0001L0.624023 41",
			stroke: "#E0E0E0",
			strokeWidth: 1.5
		})
	});
};
export default SvgSeparator;
